export enum NumberFormat {
  INT = 'INT',
  FLOAT = 'FLOAT',
  CURRENCY = 'CURRENCY',
  PERCENT = 'PERCENT',
}
